export default __webpack_public_path__ + "static/media/7.e31743a2.png";